module.exports = __webpack_public_path__ + "media/images/app_icons/android-icon-192x192-f58710ea41e7ac5e493c1ef8d74fe5f6.png";